"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var CompanyApi = /** @class */ (function (_super) {
    __extends(CompanyApi, _super);
    function CompanyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyApi.prototype.comapnyProfilepictureFilenameIdGet = function (_a, opts) {
        var filenameId = _a.filenameId;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'comapnyProfilepictureFilenameIdGet');
        var headers = {};
        return this.request({
            url: '/comapny/profilepicture/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyApiKeysApiKeyTypePost = function (_a, opts) {
        var apiKeyType = _a.apiKeyType;
        (0, runtime_1.throwIfNullOrUndefined)(apiKeyType, 'apiKeyType', 'companyApiKeysApiKeyTypePost');
        var headers = {};
        return this.request({
            url: '/company/apiKeys/{apiKeyType}'.replace('{apiKeyType}', (0, runtime_1.encodeURI)(apiKeyType)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyApiKeysApiKeyTypeRefreshPost = function (_a, opts) {
        var apiKeyType = _a.apiKeyType;
        (0, runtime_1.throwIfNullOrUndefined)(apiKeyType, 'apiKeyType', 'companyApiKeysApiKeyTypeRefreshPost');
        var headers = {};
        return this.request({
            url: '/company/apiKeys/{apiKeyType}/refresh'.replace('{apiKeyType}', (0, runtime_1.encodeURI)(apiKeyType)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleAssignmentIdGet = function (_a, opts) {
        var assignmentId = _a.assignmentId;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentId, 'assignmentId', 'companyAssignmentRuleAssignmentIdGet');
        var headers = {};
        return this.request({
            url: '/Company/AssignmentRule/{assignmentId}'.replace('{assignmentId}', (0, runtime_1.encodeURI)(assignmentId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleAssignmentRuldIdAutomationActionBlankGet = function (_a, opts) {
        var assignmentRuldId = _a.assignmentRuldId;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentRuldId, 'assignmentRuldId', 'companyAssignmentRuleAssignmentRuldIdAutomationActionBlankGet');
        var headers = {};
        return this.request({
            url: '/Company/AssignmentRule/{assignmentRuldId}/AutomationAction/Blank'.replace('{assignmentRuldId}', (0, runtime_1.encodeURI)(assignmentRuldId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleAssignmentRuldIdAutomationActionBlankPost = function (_a, opts) {
        var assignmentRuldId = _a.assignmentRuldId;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentRuldId, 'assignmentRuldId', 'companyAssignmentRuleAssignmentRuldIdAutomationActionBlankPost');
        var headers = {};
        return this.request({
            url: '/Company/AssignmentRule/{assignmentRuldId}/AutomationAction/Blank'.replace('{assignmentRuldId}', (0, runtime_1.encodeURI)(assignmentRuldId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleBlankGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/AssignmentRule/Blank',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleBlankPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsAssignmentRuleViewModel = _a.travisBackendCompanyDomainViewModelsAssignmentRuleViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/AssignmentRule/Blank',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAssignmentRuleViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleDelete = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsDeleteAssignmentRuleViewModel = _a.travisBackendCompanyDomainViewModelsDeleteAssignmentRuleViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/AssignmentRule',
            method: 'DELETE',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsDeleteAssignmentRuleViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleDuplicateAssignmentIdPost = function (_a, opts) {
        var assignmentId = _a.assignmentId;
        (0, runtime_1.throwIfNullOrUndefined)(assignmentId, 'assignmentId', 'companyAssignmentRuleDuplicateAssignmentIdPost');
        var headers = {};
        return this.request({
            url: '/Company/AssignmentRule/duplicate/{assignmentId}'.replace('{assignmentId}', (0, runtime_1.encodeURI)(assignmentId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleDuplicatePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsDuplicateAutomationRuleViewModel = _a.travisBackendCompanyDomainViewModelsDuplicateAutomationRuleViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/AssignmentRule/duplicate',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsDuplicateAutomationRuleViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, triggerType = _a.triggerType, name = _a.name;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (triggerType != null) {
            query['triggerType'] = triggerType;
        }
        if (name != null) {
            query['name'] = name;
        }
        return this.request({
            url: '/Company/AssignmentRule',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRulePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsAssignmentRuleViewModel = _a.travisBackendCompanyDomainViewModelsAssignmentRuleViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/AssignmentRule',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAssignmentRuleViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleReorderPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsAssignmentReorderViewModel = _a.travisBackendCompanyDomainViewModelsAssignmentReorderViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/AssignmentRule/reorder',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAssignmentReorderViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAssignmentRuleStatusPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsAssignmentStatusViewModel = _a.travisBackendCompanyDomainViewModelsAssignmentStatusViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/AssignmentRule/status',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAssignmentStatusViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAutomationActionAttachmentAutomationActionIdPost = function (_a, opts) {
        var automationActionId = _a.automationActionId, files = _a.files;
        (0, runtime_1.throwIfNullOrUndefined)(automationActionId, 'automationActionId', 'companyAutomationActionAttachmentAutomationActionIdPost');
        var headers = {};
        var formData = new FormData();
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        return this.request({
            url: '/Company/AutomationAction/Attachment/{automationActionId}'.replace('{automationActionId}', (0, runtime_1.encodeURI)(automationActionId)),
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyAutomationActionAutomationActionIdAttachmentAttachmentIdDelete = function (_a, opts) {
        var automationActionId = _a.automationActionId, attachmentId = _a.attachmentId;
        (0, runtime_1.throwIfNullOrUndefined)(automationActionId, 'automationActionId', 'companyAutomationActionAutomationActionIdAttachmentAttachmentIdDelete');
        (0, runtime_1.throwIfNullOrUndefined)(attachmentId, 'attachmentId', 'companyAutomationActionAutomationActionIdAttachmentAttachmentIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/AutomationAction/{automationActionId}/Attachment/{attachmentId}'.replace('{automationActionId}', (0, runtime_1.encodeURI)(automationActionId)).replace('{attachmentId}', (0, runtime_1.encodeURI)(attachmentId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyCompanyFieldsDelete = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsDeleteCompanyCustomFieldViewModel = _a.travisBackendCompanyDomainViewModelsDeleteCompanyCustomFieldViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/CompanyFields',
            method: 'DELETE',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsDeleteCompanyCustomFieldViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyCompanyFieldsFieldNameGet = function (_a, opts) {
        var fieldName = _a.fieldName;
        (0, runtime_1.throwIfNullOrUndefined)(fieldName, 'fieldName', 'companyCompanyFieldsFieldNameGet');
        var headers = {};
        return this.request({
            url: '/Company/CompanyFields/{fieldName}'.replace('{fieldName}', (0, runtime_1.encodeURI)(fieldName)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyCompanyFieldsGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/CompanyFields',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyCompanyFieldsPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsAddCompanyCustomFieldViewModel = _a.travisBackendCompanyDomainViewModelsAddCompanyCustomFieldViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/CompanyFields',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAddCompanyCustomFieldViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyDefaultInboxOrderOrderPost = function (_a, opts) {
        var order = _a.order;
        (0, runtime_1.throwIfNullOrUndefined)(order, 'order', 'companyDefaultInboxOrderOrderPost');
        var headers = {};
        return this.request({
            url: '/company/default-inbox-order/{order}'.replace('{order}', (0, runtime_1.encodeURI)(order)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyEmailConnectPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectEmailViewModel = _a.travisBackendCompanyDomainViewModelsConnectEmailViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/email/connect',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectEmailViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyEmailDomainDelete = function (_a, opts) {
        var domain = _a.domain;
        (0, runtime_1.throwIfNullOrUndefined)(domain, 'domain', 'companyEmailDomainDelete');
        var headers = {};
        return this.request({
            url: '/Company/email/{domain}'.replace('{domain}', (0, runtime_1.encodeURI)(domain)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyEmailRenameDomainPost = function (_a, opts) {
        var domain = _a.domain, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(domain, 'domain', 'companyEmailRenameDomainPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/email/rename/{domain}'.replace('{domain}', (0, runtime_1.encodeURI)(domain)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyEmailUpdateDomainPost = function (_a, opts) {
        var domain = _a.domain, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(domain, 'domain', 'companyEmailUpdateDomainPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/email/update/{domain}'.replace('{domain}', (0, runtime_1.encodeURI)(domain)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyEmailWebhookURLGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/email/webhookURL',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookConnectionURLGet = function (_a, opts) {
        var appDomainName = _a.appDomainName;
        var headers = {};
        var query = {};
        if (appDomainName != null) {
            query['appDomainName'] = appDomainName;
        }
        return this.request({
            url: '/Company/Facebook/ConnectionURL',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookPageIdDelete = function (_a, opts) {
        var pageId = _a.pageId;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'companyFacebookPageIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/Facebook/{pageId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookRenamePageIdPost = function (_a, opts) {
        var pageId = _a.pageId, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'companyFacebookRenamePageIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Facebook/rename/{pageId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookStatusPageIdGet = function (_a, opts) {
        var pageId = _a.pageId;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'companyFacebookStatusPageIdGet');
        var headers = {};
        return this.request({
            url: '/Company/Facebook/status/{pageId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookSubscribePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectFacebookViewModel = _a.travisBackendCompanyDomainViewModelsConnectFacebookViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Facebook/Subscribe',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectFacebookViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookSubscriblePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectFacebookViewModel = _a.travisBackendCompanyDomainViewModelsConnectFacebookViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Facebook/Subscrible',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectFacebookViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookSyncPageIdGet = function (_a, opts) {
        var pageId = _a.pageId;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'companyFacebookSyncPageIdGet');
        var headers = {};
        return this.request({
            url: '/company/facebook/sync/{pageId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyFacebookUpdatePageIdPost = function (_a, opts) {
        var pageId = _a.pageId, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(pageId, 'pageId', 'companyFacebookUpdatePageIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Facebook/update/{pageId}'.replace('{pageId}', (0, runtime_1.encodeURI)(pageId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyIconDelete = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/icon',
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyIconFilenameIdGet = function (_a, opts) {
        var filenameId = _a.filenameId;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'companyIconFilenameIdGet');
        var headers = {};
        return this.request({
            url: '/company/Icon/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyIconPost = function (_a, opts) {
        var files = _a.files;
        var headers = {};
        var formData = new FormData();
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        return this.request({
            url: '/Company/icon',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyInstagramConnectionURLGet = function (_a, opts) {
        var appDomainName = _a.appDomainName;
        var headers = {};
        var query = {};
        if (appDomainName != null) {
            query['appDomainName'] = appDomainName;
        }
        return this.request({
            url: '/Company/Instagram/ConnectionURL',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyInstagramInstagramPageIdDelete = function (_a, opts) {
        var instagramPageId = _a.instagramPageId;
        (0, runtime_1.throwIfNullOrUndefined)(instagramPageId, 'instagramPageId', 'companyInstagramInstagramPageIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/instagram/{instagramPageId}'.replace('{instagramPageId}', (0, runtime_1.encodeURI)(instagramPageId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyInstagramSubscribePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectFacebookViewModel = _a.travisBackendCompanyDomainViewModelsConnectFacebookViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Instagram/Subscribe',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectFacebookViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLineChannelIdDelete = function (_a, opts) {
        var channelId = _a.channelId;
        (0, runtime_1.throwIfNullOrUndefined)(channelId, 'channelId', 'companyLineChannelIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/line/{channelId}'.replace('{channelId}', (0, runtime_1.encodeURI)(channelId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLineConnectPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectLineViewModel = _a.travisBackendCompanyDomainViewModelsConnectLineViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/line/connect',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectLineViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLineRenameChannelIdPost = function (_a, opts) {
        var channelId = _a.channelId, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(channelId, 'channelId', 'companyLineRenameChannelIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/line/rename/{channelId}'.replace('{channelId}', (0, runtime_1.encodeURI)(channelId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLineUpdateChannelIdPost = function (_a, opts) {
        var channelId = _a.channelId, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(channelId, 'channelId', 'companyLineUpdateChannelIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/line/update/{channelId}'.replace('{channelId}', (0, runtime_1.encodeURI)(channelId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLineWebhookURLGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/line/webhookURL',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLiveChatWidgetSettingDelete = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/LiveChatWidgetSetting',
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyLiveChatWidgetSettingPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsCreateOrUpdateCompanyLiveChatWidgetSettingInput = _a.travisBackendCompanyDomainViewModelsCreateOrUpdateCompanyLiveChatWidgetSettingInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/LiveChatWidgetSetting',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsCreateOrUpdateCompanyLiveChatWidgetSettingInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyRequestChannelGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/Request/Channel',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyRequestChannelPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsRequestChannelViewModel = _a.travisBackendCompanyDomainViewModelsRequestChannelViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Request/Channel',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsRequestChannelViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyResendInvitationStaffIdPost = function (_a, opts) {
        var staffId = _a.staffId;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyResendInvitationStaffIdPost');
        var headers = {};
        return this.request({
            url: '/company/resendInvitation/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companySettingGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/setting',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companySettingPost = function (_a, opts) {
        var travisBackendCompanyDomainModelsCompanySetting = _a.travisBackendCompanyDomainModelsCompanySetting;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/setting',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainModelsCompanySetting,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/Company/Staff',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffOverviewsGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/Company/StaffOverviews',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffProfilePictureStaffIdDelete = function (_a, opts) {
        var staffId = _a.staffId;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffProfilePictureStaffIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/Staff/ProfilePicture/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffProfilePictureStaffIdPost = function (_a, opts) {
        var staffId = _a.staffId, files = _a.files;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffProfilePictureStaffIdPost');
        var headers = {};
        var formData = new FormData();
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        return this.request({
            url: '/Company/Staff/ProfilePicture/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffQrcodeGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/Staff/Qrcode',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffQrcodeStaffIdGet = function (_a, opts) {
        var staffId = _a.staffId;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffQrcodeStaffIdGet');
        var headers = {};
        return this.request({
            url: '/Company/Staff/Qrcode/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffQrcodeStaffIdPost = function (_a, opts) {
        var staffId = _a.staffId, travisBackendCompanyDomainViewModelsStaffInfoViewModel = _a.travisBackendCompanyDomainViewModelsStaffInfoViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffQrcodeStaffIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/staff/qrcode/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsStaffInfoViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffStaffIdDelete = function (_a, opts) {
        var staffId = _a.staffId;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffStaffIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/Staff/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffStaffIdGet = function (_a, opts) {
        var staffId = _a.staffId;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffStaffIdGet');
        var headers = {};
        return this.request({
            url: '/Company/Staff/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyStaffStaffIdPost = function (_a, opts) {
        var staffId = _a.staffId, travisBackendCompanyDomainViewModelsStaffInfoViewModel = _a.travisBackendCompanyDomainViewModelsStaffInfoViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'companyStaffStaffIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Staff/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsStaffInfoViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTelegramConnectPost = function (_a, opts) {
        var travisBackendChannelDomainViewModelsConnectTelegramInput = _a.travisBackendChannelDomainViewModelsConnectTelegramInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/telegram/connect',
            method: 'POST',
            headers: headers,
            body: travisBackendChannelDomainViewModelsConnectTelegramInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTelegramDelete = function (_a, opts) {
        var travisBackendChannelDomainViewModelsDeleteTelegramInput = _a.travisBackendChannelDomainViewModelsDeleteTelegramInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/telegram',
            method: 'DELETE',
            headers: headers,
            body: travisBackendChannelDomainViewModelsDeleteTelegramInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTelegramGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/telegram',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTelegramPut = function (_a, opts) {
        var travisBackendChannelDomainViewModelsEditTelegramInput = _a.travisBackendChannelDomainViewModelsEditTelegramInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/telegram',
            method: 'PUT',
            headers: headers,
            body: travisBackendChannelDomainViewModelsEditTelegramInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTelegramReconnectPost = function (_a, opts) {
        var travisBackendChannelDomainViewModelsReconnectTelegramInput = _a.travisBackendChannelDomainViewModelsReconnectTelegramInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/telegram/reconnect',
            method: 'POST',
            headers: headers,
            body: travisBackendChannelDomainViewModelsReconnectTelegramInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTimezoneGet = function (_a, opts) {
        var id = _a.id, countryCode = _a.countryCode, countryName = _a.countryName, ianaId = _a.ianaId;
        var headers = {};
        var query = {};
        if (id != null) {
            query['Id'] = id;
        }
        if (countryCode != null) {
            query['countryCode'] = countryCode;
        }
        if (countryName != null) {
            query['countryName'] = countryName;
        }
        if (ianaId != null) {
            query['ianaId'] = ianaId;
        }
        return this.request({
            url: '/company/timezone',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioOptinGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/twilio/optin',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioOptinPost = function (_a, opts) {
        var travisBackendChannelDomainModelsOptinObject = _a.travisBackendChannelDomainModelsOptinObject;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/twilio/optin',
            method: 'POST',
            headers: headers,
            body: travisBackendChannelDomainModelsOptinObject,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioSmsPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectTwilioViewModel = _a.travisBackendCompanyDomainViewModelsConnectTwilioViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/twilio/sms',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectTwilioViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioSmsRenameSIDPost = function (_a, opts) {
        var sID = _a.sID, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(sID, 'sID', 'companyTwilioSmsRenameSIDPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/twilio/sms/rename/{SID}'.replace('{SID}', (0, runtime_1.encodeURI)(sID)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioSmsSIDDelete = function (_a, opts) {
        var sID = _a.sID;
        (0, runtime_1.throwIfNullOrUndefined)(sID, 'sID', 'companyTwilioSmsSIDDelete');
        var headers = {};
        return this.request({
            url: '/Company/twilio/sms/{SID}'.replace('{SID}', (0, runtime_1.encodeURI)(sID)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioSmsUpdateSIDPost = function (_a, opts) {
        var sID = _a.sID, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(sID, 'sID', 'companyTwilioSmsUpdateSIDPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/twilio/sms/update/{SID}'.replace('{SID}', (0, runtime_1.encodeURI)(sID)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioUsageGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/twilio/usage',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioWhatsappDelete = function (_a, opts) {
        var sID = _a.sID;
        var headers = {};
        var query = {};
        if (sID != null) {
            query['SID'] = sID;
        }
        return this.request({
            url: '/Company/twilio/whatsapp',
            method: 'DELETE',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioWhatsappPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectTwilioViewModel = _a.travisBackendCompanyDomainViewModelsConnectTwilioViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/twilio/whatsapp',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectTwilioViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioWhatsappRenameSIDPost = function (_a, opts) {
        var sID2 = _a.sID2, sID = _a.sID, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(sID2, 'sID2', 'companyTwilioWhatsappRenameSIDPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (sID != null) {
            query['SID'] = sID;
        }
        return this.request({
            url: '/Company/twilio/whatsapp/rename/{SID}'.replace('{SID}', (0, runtime_1.encodeURI)(sID2)),
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioWhatsappSIDDelete = function (_a, opts) {
        var sID2 = _a.sID2, sID = _a.sID;
        (0, runtime_1.throwIfNullOrUndefined)(sID2, 'sID2', 'companyTwilioWhatsappSIDDelete');
        var headers = {};
        var query = {};
        if (sID != null) {
            query['SID'] = sID;
        }
        return this.request({
            url: '/Company/twilio/whatsapp/{SID}'.replace('{SID}', (0, runtime_1.encodeURI)(sID2)),
            method: 'DELETE',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyTwilioWhatsappUpdatePost = function (_a, opts) {
        var sID = _a.sID, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (sID != null) {
            query['SID'] = sID;
        }
        return this.request({
            url: '/Company/twilio/whatsapp/update',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyUpdatePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsUpdateCompanyNameViewModel = _a.travisBackendCompanyDomainViewModelsUpdateCompanyNameViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/Update',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsUpdateCompanyNameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyUsageGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/usage',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyUserProfileFieldDelete = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsDeleteCustomUserFieldViewModel = _a.travisBackendCompanyDomainViewModelsDeleteCustomUserFieldViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/UserProfileField',
            method: 'DELETE',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsDeleteCustomUserFieldViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyUserProfileFieldsPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsAddUserProfileCustomFieldViewModel = _a.travisBackendCompanyDomainViewModelsAddUserProfileCustomFieldViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/UserProfileFields',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsAddUserProfileCustomFieldViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyV2InvitePost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsInviteV2TeammateViewModel = _a.travisBackendCompanyDomainViewModelsInviteV2TeammateViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/v2/invite',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsInviteV2TeammateViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyViberConnectPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectViberInput = _a.travisBackendCompanyDomainViewModelsConnectViberInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/viber/connect',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectViberInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyViberDelete = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsDeleteViberInput = _a.travisBackendCompanyDomainViewModelsDeleteViberInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/viber',
            method: 'DELETE',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsDeleteViberInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyViberGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/viber',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyViberPut = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsEditViberInput = _a.travisBackendCompanyDomainViewModelsEditViberInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/viber',
            method: 'PUT',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsEditViberInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyViberReconnectPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsReconnectViberInput = _a.travisBackendCompanyDomainViewModelsReconnectViberInput;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/viber/reconnect',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsReconnectViberInput,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyWechatAppIdDelete = function (_a, opts) {
        var appId = _a.appId;
        (0, runtime_1.throwIfNullOrUndefined)(appId, 'appId', 'companyWechatAppIdDelete');
        var headers = {};
        return this.request({
            url: '/Company/wechat/{appId}'.replace('{appId}', (0, runtime_1.encodeURI)(appId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyWechatConnectPost = function (_a, opts) {
        var travisBackendCompanyDomainViewModelsConnectWeChatViewModel = _a.travisBackendCompanyDomainViewModelsConnectWeChatViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/wechat/connect',
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsConnectWeChatViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyWechatQrcodeAppIdPost = function (_a, opts) {
        var appId = _a.appId, files = _a.files;
        (0, runtime_1.throwIfNullOrUndefined)(appId, 'appId', 'companyWechatQrcodeAppIdPost');
        var headers = {};
        var formData = new FormData();
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        return this.request({
            url: '/Company/wechat/qrcode/{appId}'.replace('{appId}', (0, runtime_1.encodeURI)(appId)),
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyWechatRenameAppIdPost = function (_a, opts) {
        var appId = _a.appId, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(appId, 'appId', 'companyWechatRenameAppIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/wechat/rename/{appId}'.replace('{appId}', (0, runtime_1.encodeURI)(appId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyWechatUpdateAppIdPost = function (_a, opts) {
        var appId = _a.appId, travisBackendCompanyDomainViewModelsChannelRenameViewModel = _a.travisBackendCompanyDomainViewModelsChannelRenameViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(appId, 'appId', 'companyWechatUpdateAppIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Company/wechat/update/{appId}'.replace('{appId}', (0, runtime_1.encodeURI)(appId)),
            method: 'POST',
            headers: headers,
            body: travisBackendCompanyDomainViewModelsChannelRenameViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.companyWechatWebhookURLGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Company/wechat/webhookURL',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.v2CompanyOnboardingProgressGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/v2/Company/OnboardingProgress',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.v2CompanyStaffGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, staffName = _a.staffName;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (staffName != null) {
            query['staffName'] = staffName;
        }
        return this.request({
            url: '/v2/company/Staff',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.v2CompanyStaffStaffIdGet = function (_a, opts) {
        var staffId = _a.staffId;
        (0, runtime_1.throwIfNullOrUndefined)(staffId, 'staffId', 'v2CompanyStaffStaffIdGet');
        var headers = {};
        return this.request({
            url: '/v2/Company/Staff/{staffId}'.replace('{staffId}', (0, runtime_1.encodeURI)(staffId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CompanyApi.prototype.webchatQrcodeFilenameIdGet = function (_a, opts) {
        var filenameId = _a.filenameId;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'webchatQrcodeFilenameIdGet');
        var headers = {};
        return this.request({
            url: '/webchat/qrcode/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return CompanyApi;
}(runtime_1.BaseAPI));
exports.CompanyApi = CompanyApi;
